export function isMissing<T>(value: T | null): value is null {
  return value === undefined || value === null;
}

export function isPresent<T>(value: T | null): value is NonNullable<T> {
  return !isMissing(value);
}

export function isBlank<T>(value: T | null | undefined): boolean {
  if (isMissing(value)) return true;

  if (Array.isArray(value)) return value.length === 0;

  if (typeof value === 'object')
    return Object.keys((value as unknown) as object).length === 0;

  return !value;
}

export const objectToParams = (object: {
  [k: string]: string | number | boolean | null | undefined | string[];
}) => {
  return Object.entries(object)
    .reduce((acc: Array<string>, [key, value]) => {
      if (value) {
        return [...acc, `${key}=${value}`];
      }
      return acc;
    }, [])
    .join('&');
};

export const objectToEncodedParams = (object: {
  [k: string]: string | number | boolean | null | undefined | string[];
}) => {
  return Object.entries(object)
    .reduce((acc: Array<string>, [key, value]) => {
      if (value) {
        let encodedValue = encodeURIComponent(value.toString());
        return [...acc, `${key}=${encodedValue}`];
      }
      return acc;
    }, [])
    .join('&');
};

export const isEqual = (
  value?: Record<string, any>,
  other?: Record<string, any>
) => {
  if (value === other) {
    return true;
  }

  if (
    !value ||
    typeof value !== 'object' ||
    !other ||
    typeof other !== 'object'
  ) {
    return false;
  }

  const valueKeys = Object.keys(value);
  const otherKeys = Object.keys(other);

  if (valueKeys.length !== otherKeys.length) {
    return false;
  }

  for (const key of valueKeys) {
    if (!(key in other) || !isEqual(value[key], other[key])) {
      return false;
    }
  }

  return true;
};

export const findByMatchingProperties = async (set: any[], properties: any) => {
  return set.filter(function(entry: { [x: string]: any }) {
    return Object.keys(properties).every(function(key) {
      return entry[key] === properties[key];
    });
  });
};
